// Implementation partners — names sourced from Lenovo India CSR's public partner portfolio
// pillar: "stem" | "digital" | "employability" | "sustainability"

const BASE_PARTNERS = [
  // ── STEM Education ──────────────────────────────────────────────
  { id: "agastya",     name: "Agastya International Foundation", pillar: "stem",          states: ["Karnataka", "Maharashtra", "Delhi"],           beneficiaries: 8200, fundedCr: 3.6, since: 2018, program: "Mobile science · Lab-on-a-Tab" },
  { id: "meghshala",   name: "Meghshala Trust",                  pillar: "stem",          states: ["Karnataka", "Manipur", "Meghalaya"],          beneficiaries: 4100, fundedCr: 2.2, since: 2019, program: "Teacher enablement · vernacular content" },

  // ── Digital Literacy ────────────────────────────────────────────
  { id: "muskaan",     name: "Muskaan Dreams (with Motorola)",   pillar: "digital",       states: ["Uttar Pradesh"],                              beneficiaries: 3600, fundedCr: 2.0, since: 2025, program: "Innovators of Tomorrow · coding, AI" },
  { id: "yuva",        name: "YUVA Unstoppable",                 pillar: "digital",       states: ["Gujarat"],                                    beneficiaries: 2800, fundedCr: 1.6, since: 2021, program: "Tablet lending / learning model" },
  { id: "evidyaloka",  name: "eVidyaloka",                       pillar: "digital",       states: ["Karnataka", "Tamil Nadu", "Jharkhand", "Assam"], beneficiaries: 5200, fundedCr: 2.4, since: 2020, program: "SmarterEd online platform" },

  // ── Employability & Skilling ────────────────────────────────────
  { id: "technoserve", name: "TechnoServe India",                pillar: "employability", states: ["Maharashtra"],                                beneficiaries: 1900, fundedCr: 1.8, since: 2020, program: "Employability skills for young women" },
  { id: "tns",         name: "TNS India Foundation",             pillar: "employability", states: ["Puducherry"],                                 beneficiaries: 1200, fundedCr: 1.3, since: 2021, program: "Campus to Corporate Careers" },
  { id: "edubridge",   name: "EduBridge · Udyogini · Medha",     pillar: "employability", states: ["Karnataka", "Maharashtra", "Telangana"],      beneficiaries: 3400, fundedCr: 2.6, since: 2019, program: "Skill development · multi-state" },

  // ── Sustainability ──────────────────────────────────────────────
  { id: "dreamindia",  name: "Dream India Network",              pillar: "sustainability",states: ["Kerala"],                                     beneficiaries: 1400, fundedCr: 1.5, since: 2022, program: "Work for Humankind — millet revival" },
  { id: "saahas",      name: "Saahas Zero Waste",                pillar: "sustainability",states: ["Karnataka", "Maharashtra"],                   beneficiaries: 820,  fundedCr: 1.9, since: 2021, program: "E-waste circularity & recycling" },
  { id: "sankalptaru", name: "SankalpTaru Foundation",           pillar: "sustainability",states: ["Uttarakhand", "Tamil Nadu", "Karnataka"],     beneficiaries: 0,    fundedCr: 1.7, since: 2020, program: "Native tree plantation", trees: 185000 },
];

// Deterministic 32-bit hash so values are stable across renders / FY switches
function hash(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return (h >>> 0);
}

function pick(seed, arr) {
  return arr[seed % arr.length];
}

function enrich(p) {
  const h1 = hash(p.id + ":score");
  const h2 = hash(p.id + ":kpi");
  const h3 = hash(p.id + ":compliance");
  const h4 = hash(p.id + ":count");
  const h5 = hash(p.id + ":grants");
  const h6 = hash(p.id + ":util");

  const avgScore = +(3.2 + ((h1 % 170) / 100)).toFixed(2);   // 3.2 .. 4.9
  const kpiCompletion = 45 + (h2 % 56);                       // 45 .. 100
  const grantCount = 1 + (h5 % 3);                            // 1 .. 3
  const utilisationPct = 58 + (h6 % 40);                      // 58 .. 97
  const utilisedCr = +(p.fundedCr * (utilisationPct / 100)).toFixed(2);

  const types = ["all_submitted", "all_submitted", "all_submitted", "reports_overdue", "reports_overdue", "uc_overdue"];
  const complianceType = pick(h3, types);
  const overdueCount = complianceType === "all_submitted"
    ? 0
    : 1 + (h4 % Math.max(1, Math.min(2, grantCount)));

  return {
    ...p,
    avgScore,
    kpiCompletion,
    grantCount,
    utilisationPct,
    utilisedCr,
    compliance: { type: complianceType, count: overdueCount },
  };
}

export const PARTNERS = BASE_PARTNERS.map(enrich);

export const partnersByPillar = (pillarId) =>
  PARTNERS.filter((p) => p.pillar === pillarId);

// ─── Helpers used by the Partner cards ─────────────────────────────────────
export const scoreRAG = (score) => {
  if (score >= 4.0) return { tone: "green", label: "Strong",   dot: "#16A34A" };
  if (score >= 3.4) return { tone: "amber", label: "On watch", dot: "#D97706" };
  return                    { tone: "red",   label: "At risk", dot: "#DC2626" };
};

export const kpiRAG = (pct) => {
  if (pct >= 80) return { tone: "green", label: "On track", dot: "#16A34A" };
  if (pct >= 50) return { tone: "amber", label: "At risk",  dot: "#D97706" };
  return                { tone: "red",   label: "Behind",   dot: "#DC2626" };
};

export const COMPLIANCE_META = {
  all_submitted:   { label: "All reports submitted", tone: "green" },
  reports_overdue: { label: "Report overdue",        tone: "amber" },
  uc_overdue:      { label: "UC overdue",            tone: "red"   },
};

export const TONE_CHIP = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  amber: "bg-amber-50  text-amber-700  border-amber-200",
  red:   "bg-rose-50   text-rose-700   border-rose-200",
};
